/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { createContext, useContext, type ReactNode } from 'react';
import type { Table } from '@tanstack/react-table';

// Simple context type - most components will use Record<string, unknown> as TData
export interface TableContextValue {
  table: Table<Record<string, unknown>>;
  // Additional custom properties for backward compatibility
  [key: string]: unknown;
}

export interface TableProviderProps {
  children: ReactNode;
  value: TableContextValue;
}

const TableContext = createContext<TableContextValue | null>(null);

export function TableProvider({ children, value }: TableProviderProps) {
  return <TableContext.Provider value={value}>{children}</TableContext.Provider>;
}

export function useTableContext(): TableContextValue {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context;
}
